import React from 'react';
import { FaRocket } from 'react-icons/fa';

interface OverrideFunctionProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const OverrideFunction: React.FC<OverrideFunctionProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      className="buttonCommon columnDown"
      title="Override Function"
      onClick={onClick}
    >
      <span
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "5px",
          color: "rgb(211, 211, 211)",
        }}
      >
        <FaRocket />
      </span>
    </button>
  );
};

export default OverrideFunction;
